var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-progress"},[_c('div',{staticClass:"border",style:(_vm.borderWidth)}),_c('div',{staticClass:"pips"},_vm._l((_vm.total),function(pip,index){return _c('div',{key:`pip-${index}`,staticClass:"pip",class:{'is-active': index < _vm.step}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }